import React from 'react'

export default function Home() {
  return (
    <div className='homeMain d-flex align-items-center' id='home'>
        <div className='container w-75 my-auto'>
            <h1 className='rofontbotoBold OutlineTitle'>MARKETO</h1>
            <p className='rofontbotoBold fs-5'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
            <a href='#services'><button className='button fs-6 my-4'>Discover</button></a>
        </div>
    </div>
  )
}
